import { type CreateSingleRecordActionConfig } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useDataSourceOptions } from '@/hooks/useDataSource'

import * as CM from '../styles'
import * as SC from './styles'

type CreateSingleRecordCardProps = {
    config: CreateSingleRecordActionConfig
}

const CreateSingleRecordCard: React.FC<CreateSingleRecordCardProps> = ({ config }) => {
    const options = useDataSourceOptions()
    const option = useMemo(
        () => (config?.dataSourceId ? options.find(item => item.value === config.dataSourceId) : undefined),
        [config.dataSourceId, options]
    )

    if (!option) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>记录创建到</SC.TypeName>
            <CM.FieldList>
                <CM.FieldItem>
                    <CM.FieldItemLeftFill>
                        <SC.Icon type={option?.icon ?? ''} />
                        <CM.FieldItemTitle>{option?.label}</CM.FieldItemTitle>
                    </CM.FieldItemLeftFill>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default CreateSingleRecordCard
